// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  display: flex;
  position: relative;
  flex-direction: column;
}

.about-container {
  display: flex;
  position: relative;
  flex-direction: column;
  transition: all 1s ease-in-out;
  padding-top: 10px;
  background-image: linear-gradient(to right, #390879, #390879, #390879, #390879, #390879, #311379, #2a1a78, #231f76, #152871, #0e2e6a, #133261, #1d3557);
  overflow: hidden;
  height: 11em;
  justify-content: center;
  align-items: center;
}

.about-header {
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  font-size: 50px;
  border-bottom: 1px solid white;
  margin: 5px;
}

.about-esther {
  background-color: white;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
  margin-top: 100px;
  padding-bottom: 100px;
}

.about-name-container {
  font-family: "Spartan", sans-serif;
  color: #1d3557;
  font-size: 30px;
  display: flex;
  flex-direction: column;
  width: 50%;
}

.about-title {
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  font-size: 40px;
  font-weight: bold;
  margin-left: 5px;
}

.about-name {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  margin: 20px;
}

.about-description {
  font-size: 15px;
}

.about-me {
  display: flex;
  flex-direction: column;
  margin: 2rem;
  gap: 1em;
}

.about-img {
  width: 600px;
  height: 400px;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  border: 1px solid rgba(0, 35, 70, 0.2);
  box-sizing: inherit;
}

.about-msg {
  color: #551fbd;
  letter-spacing: 0.05em;
  font-family: "Parisienne", cursive;
}

@media (max-width: 500px) {
  .about-header {
    font-size: 2rem;
  }
  .about-esther {
    flex-direction: column;
    width: 100%;
  }
  .about-name-container {
    width: 100%;
  }
  .about-msg {
    padding: 1rem;
    width: 30rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/About/Styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAEE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,uJAAA;EAeA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;;AAgBE;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AAbJ;;AAgBE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,iBAAA;EACA,qBAAA;AAbJ;;AAgBE;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AAbJ;;AAgBE;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAbJ;;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AAbJ;;AAgBE;EACE,eAAA;AAbJ;;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,QAAA;AAbJ;;AAgBE;EACE,YAAA;EACA,aAAA;EACA,2BAAA;EACA,8CAAA;EACA,sCAAA;EACA,mBAAA;AAbJ;;AAgBE;EACE,cAAA;EACA,sBAAA;EACA,kCAAA;AAbJ;;AAgBE;EACE;IACE,eAAA;EAbJ;EAgBE;IACE,sBAAA;IACA,WAAA;EAdJ;EAiBE;IACE,WAAA;EAfJ;EAkBE;IACE,aAAA;IACA,YAAA;EAhBJ;AACF","sourcesContent":[".about {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n  }\n  \n  .about-container {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    transition: all 1s ease-in-out;\n    padding-top: 10px;\n    background-image: linear-gradient(\n      to right,\n      #390879,\n      #390879,\n      #390879,\n      #390879,\n      #390879,\n      #311379,\n      #2a1a78,\n      #231f76,\n      #152871,\n      #0e2e6a,\n      #133261,\n      #1d3557\n    );\n    overflow: hidden;\n    height: 11em;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .about-header {\n    font-family: \"Spartan\", sans-serif;\n    color: #a5e300;\n    font-size: 50px;\n    border-bottom: 1px solid white;\n    margin: 5px;\n  }\n  \n  .about-esther {\n    background-color: white;\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-evenly;\n    margin-top: 100px;\n    padding-bottom: 100px;\n  }\n  \n  .about-name-container {\n    font-family: \"Spartan\", sans-serif;\n    color: #1d3557;\n    font-size: 30px;\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n  }\n  \n  .about-title {\n    font-family: \"Spartan\", sans-serif;\n    color: #a5e300;\n    font-size: 40px;\n    font-weight: bold;\n    margin-left: 5px;\n  }\n  \n  .about-name {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: baseline;\n    margin: 20px;\n  }\n  \n  .about-description {\n    font-size: 15px;\n  }\n  \n  .about-me {\n    display: flex;\n    flex-direction: column;\n    margin: 2rem;\n    gap: 1em;\n  }\n  \n  .about-img {\n    width: 600px;\n    height: 400px;\n    transform: translateY(-1px);\n    box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n    border: 1px solid rgba(0, 35, 70, 0.2);\n    box-sizing: inherit;\n  }\n  \n  .about-msg {\n    color: #551fbd;\n    letter-spacing: 0.05em;\n    font-family: \"Parisienne\", cursive;\n  }\n  \n  @media (max-width: 500px) {\n    .about-header {\n      font-size: 2rem;\n    }\n  \n    .about-esther {\n      flex-direction: column;\n      width: 100%;\n    }\n  \n    .about-name-container {\n      width: 100%;\n    }\n  \n    .about-msg {\n      padding: 1rem;\n      width: 30rem;\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
